import { useState } from 'react';
import { FormControl } from 'react-bootstrap';

interface INumbersToSelectProps {
    returnedRows: number,
    onTurnPage: (count: number) => void
}

const NumbersToSelect = (props: INumbersToSelectProps) => {
    const [selectedCount, setSelectedCount] = useState(1);

    const handleCountChange = (event) => {
        const newCount = parseInt(event.target.value);
        setSelectedCount(newCount);

        props.onTurnPage(newCount)

    };

    const options = [];

    const number = props.returnedRows;

    // Calculate the number of selects needed
    const numSelects = Math.ceil(number / 2000);

    for (let i = 1; i <= numSelects; i++) {
        const start = (i - 1) * 2000 + 1;
        const end = Math.min(i * 2000, number);
        const optionLabel = `${start}-${end}`;

        options.push(
            <option key={i} value={start}>
                {optionLabel}
            </option>
        );
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: 5 }}>
            <div style={{ fontSize: 12 }}>Select Rows: &nbsp;</div>
            <div>
                <FormControl
                    componentClass='select'
                    bsSize='sm'
                    value={selectedCount}
                    onChange={handleCountChange}>
                    {options}
                </FormControl>
            </div>
        </div>
    );
};

export default NumbersToSelect;